import React,{useState} from 'react';
import expendArrow from '../../../assets/icons/Expand Arrow.png';

const filterType = [
    { "value": "all", "label": "Yesterday" },
    { "value": "notStarted", "label": "7 Days" },
    { "value": "completed", "label": "1 Month" }
]

const FilterPanel = () => {
    const {filter,setFilter} = useState(filterType[0]);

    const handleSelect = (v) => {
        setFilter(v);
    }

    return (
        <select
            className="w-[100px] px-2 py-1 text-xs bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 hover:border-gray-400 cursor-pointer"
            name="filter-range"
            id="range"
        >
            {
                filterType && filterType.map((v,el) => {
                    return (
                        <option value={v.value} key={el} className="cursor-pointer">{v.label}</option>
                    )
                })
            }
        </select>
    )
}

export default FilterPanel